export const ROLLOUT_PHASE = Number(process.env.REACT_APP_ROLLOUT_PHASE || 3);

const FEATURE_PHASES = {
  dashboard: 1,
  approvals: 1,
  procurement: 1,
  timeline: 1,
  protocols: 2,
  inventory: 3,
  cellMaintenance: 3,
  mouseRecords: 3,
  experimentTracking: 2,
  installableWebApp: 4,
  financials: 3,
  expenseLogs: 5,
};

export function isFeatureEnabled(feature) {
  return ROLLOUT_PHASE >= (FEATURE_PHASES[feature] || 1);
}
